import { render, staticRenderFns } from "./ProjectReservation.vue?vue&type=template&id=1948359e&"
import script from "./ProjectReservation.vue?vue&type=script&lang=js&"
export * from "./ProjectReservation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReservation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports